module.exports = __webpack_public_path__ + "img/368.e9f3199c.png";